import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    cart: {
        id: null,
        discounts: [],
        outlet: {
            company_details: {},
        },
        line_items: [
            {
                item_type: null,
                applied_discounts: [],
                cancel_details: null,
            },
        ],
        order_drawer_session: {},
    },
};

const getters = {
    pgsqlCart: state => state.cart,

    outlet: state => state.cart.outlet,

    orderDrawerSession: state => state.cart.order_drawer_session,

    cancelledCart: state => {
        return {
            cancelled_cart_number: state.cart.id,
        };
    },

    sumCancelledCart: state => {
        return Math.abs(
            state.cart.line_items
                .filter(lineItem => !lineItem.cancel_details)
                .map(lineItem => {
                    return parseFloat(lineItem.amount);
                })
                .reduce((a, b) => a + b, 0),
        ).toFixed(2);
    },

    fuels: state => {
        return state.cart.line_items.filter(lineItem => {
            return lineItem.item_type === 'fuel';
        });
    },

    products: state => {
        return state.cart.line_items.filter(lineItem => {
            return lineItem.item_type === 'cstore' && !lineItem.cancel_details;
        });
    },

    cancelProducts: state => {
        return state.cart.line_items.filter(lineItem => {
            return lineItem.item_type === 'cstore' && lineItem.cancel_details;
        });
    },
};

const mutations = {
    setCart(state, data) {
        state.cart = data;
    },
};

const actions = {
    async getCart({ dispatch, commit }, cancelled_cart_number) {
        startLoading(dispatch, 'fetch-cart');

        let url = Laroute.route(
            'franchise.report.cancelled_cart.detailsPostgres',
            {
                cancelled_cart_number,
            },
        );

        try {
            const { data } = await axios.get(url);
            endLoading(dispatch, 'fetch-cart');

            commit('setCart', data);

            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-cart');
            throw e;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/cart-postgres.js